import type { SelectOption, SelectedValue } from '../types.tsx';

export const isSelectOptionArray = (options: SelectedValue): options is SelectOption[] =>
	options != null && Array.isArray(options);
